var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowsLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_987_5271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1095 18.5211C11.2172 18.5185 11.3217 18.4836 11.4095 18.4211C11.6038 18.2489 11.6302 17.9551 11.4695 17.7511L7.00949 11.8911C6.97843 11.8509 6.96092 11.8019 6.95949 11.7511C6.95949 11.697 6.97703 11.6444 7.00949 11.6011L11.4695 5.75111C11.5089 5.70366 11.5394 5.64945 11.5595 5.59111C11.5694 5.53152 11.5694 5.47071 11.5595 5.41111C11.5485 5.34846 11.5283 5.2878 11.4995 5.23111C11.4717 5.17812 11.4344 5.13067 11.3895 5.09111C11.3416 5.05466 11.2874 5.02752 11.2295 5.01111C11.1704 4.9963 11.1086 4.9963 11.0495 5.01111C10.9898 5.00221 10.9292 5.00221 10.8695 5.01111C10.8162 5.04263 10.7688 5.08324 10.7295 5.13111L6.26949 11.0111C5.91018 11.4277 5.91018 12.0446 6.26949 12.4611L10.7495 18.3511C10.7928 18.4055 10.8474 18.4499 10.9095 18.4811C10.9725 18.5086 11.0407 18.5223 11.1095 18.5211Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1095 18.5211C16.2172 18.5185 16.3217 18.4836 16.4095 18.4211C16.6038 18.2489 16.6302 17.9551 16.4695 17.7511L12.0095 11.8911C11.9784 11.8509 11.9609 11.8019 11.9595 11.7511C11.9595 11.697 11.977 11.6444 12.0095 11.6011L16.4695 5.75111C16.5089 5.70366 16.5394 5.64945 16.5595 5.59111C16.5694 5.53152 16.5694 5.47071 16.5595 5.41111C16.5485 5.34846 16.5283 5.2878 16.4995 5.23111C16.4717 5.17812 16.4344 5.13067 16.3895 5.09111C16.3416 5.05466 16.2874 5.02752 16.2295 5.01111C16.1704 4.9963 16.1086 4.9963 16.0495 5.01111C15.9898 5.00221 15.9292 5.00221 15.8695 5.01111C15.8162 5.04263 15.7688 5.08324 15.7295 5.13111L11.2695 11.0111C10.9102 11.4277 10.9102 12.0446 11.2695 12.4611L15.7495 18.3511C15.7928 18.4055 15.8474 18.4499 15.9095 18.4811C15.9725 18.5086 16.0407 18.5223 16.1095 18.5211Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_987_5271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsLeft);
export default __webpack_public_path__ + "static/media/arrows-left.1c0af957.svg";
export { ForwardRef as ReactComponent };